<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <h3 class="page-title"  v-if="userType=='supplier'">{{ $tc('customers.view_customer') }}</h3>
          <h3 class="page-title"  v-else-if="userType=='funder'">{{ $tc('clients.client',2) }}</h3>
          <h3 class="page-title"  v-else-if="userType=='anchor'">{{ $tc('customers.view_customer') }}</h3>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link slot="item-title" to="/supplier/dashboard" v-if="userType=='supplier'">{{ $t('general.home') }}</router-link>
              <router-link slot="item-title" to="/funder/dashboard" v-else-if="userType=='funder'">{{ $t('general.home') }}</router-link>
              <router-link slot="item-title" to="/anchor/dashboard" v-else-if="userType=='anchor'">{{ $t('general.home') }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link slot="item-title" to="/supplier/customers" v-if="userType=='supplier'">  {{ $tc('customers.customer',2) }}</router-link>
              <router-link slot="item-title" to="/funder/clients" v-else-if="userType=='funder'">  {{ $tc('clients.client',2) }}</router-link>
              <router-link slot="item-title" to="/anchor/customers" v-else-if="userType=='anchor'">  {{ $tc('customers.customer',2) }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <a  href="#/" slot="item-title" @click="viewCustomerPage" >
              {{ userType=='funder' ? $tc('clients.view_client')  : $tc('customers.view_customer')  }}
              </a>
            </li>
          </ol>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 align-self-center">
          <h3 class="text-center" v-if="viewCustomer && viewCustomer.name !=null">{{ viewCustomer.name }}</h3>
        </div>
      </div>

    </div>
    <div class="row settings-container">
      <div class="col-lg-4 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in finalMenuItems" :key="index"  class='sub-menu settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;">
             <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(menuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul>
              <li v-for="(childItem, childIndex) in menuItem.children" :key="childIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(childItem.link)}]" :to="childItem.link">
                  <font-awesome-icon :icon="[childItem.iconType, childItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(childItem.title) }}</span>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- <li v-for="(menuItem, index) in finalMenuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li> -->
        </ol>

        <ol class="settings-sidebar" v-if="funderProcessingMenu && userType=='funder' ">
          <li v-for="(profileMenuItem, profileMenuIndex) in profileMenuItems" :key="profileMenuIndex"  class='settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;" @click="profileMenuToggle(profileMenuIndex)">
             <font-awesome-icon :icon="[profileMenuItem.iconType, profileMenuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(profileMenuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul  :id="'profile-submenu-'+profileMenuIndex" style="display:none">
              <li v-for="(childItem, childIndex) in profileMenuItem.children" :key="childIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(childItem.link)}]" :to="childItem.link">
                  <font-awesome-icon :icon="[childItem.iconType, childItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(childItem.title) }}</span>
                </router-link>
              </li>
              <li class="settings-menu-item">
                <a class='link-color' :href="`/users/BBFS/pdf/${user}`" target="_blank">
                  <font-awesome-icon icon="eye" class="setting-icon"/>
                  <span class="menu-title ml-3">{{ $t('general.view_bbfs') }}</span>
                </a>
              </li>

            </ul>
          </li>
        </ol>
        <ol class="settings-sidebar" v-if="funderProcessingMenu && userType=='funder' ">
          <li v-for="(processMenuItem, processMenuIndex) in processMenuItems" :key="processMenuIndex"  class='settings-menu-item'>
            <a href='#' class="link-color py-2 position: relative;" @click="processMenuToggle(processMenuIndex)">
             <font-awesome-icon :icon="[processMenuItem.iconType, processMenuItem.icon]" class="setting-icon"/>
              <span class="ml-3">{{ $t(processMenuItem.title) }}</span>
              <div class="right-arrow-submenu">
                <font-awesome-icon icon="caret-down" class="setting-icon"/>
              </div>
            </a>
            <ul  :id="'process-submenu-'+processMenuIndex" style="display:none">
              <li v-for="(procesChildItem, processChildIndex) in processMenuItem.children" :key="processChildIndex" class="settings-menu-item">
                <router-link :class="['link-color', {'active-setting': hasActiveUrl(procesChildItem.link)}]" :to="procesChildItem.link">
                  <font-awesome-icon :icon="[procesChildItem.iconType, procesChildItem.icon]" class="setting-icon"/>
                  <span class="ml-3">{{ $t(procesChildItem.title) }}</span>
                </router-link>
              </li>
            </ul>
          </li>

        </ol>
      </div>
      <div class="col-lg-8">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
        id:null,
        userType:null,
        funderProcessingMenu:false,
        finalMenuItems:[],
        profileMenuItems:[
          {
            title: 'general.financial_profile',
            icon: 'money-bill-alt',
            iconType: 'fa',
            children:[
              {
              link:  `/funder/clients/${this.$route.params.id}/view/business-status`,
              title: 'profile.menu_title.business_status',
              icon: 'building',
              iconType: 'fa'
              },
              {
              link: `/funder/clients/${this.$route.params.id}/view/borrower-profile`,
              title: 'profile.menu_title.borrower_profile',
              icon: 'user-tie',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/stakeholder`,
              title: 'profile.menu_title.stakeholder',
              icon: 'user-friends',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/business_financial_institutions`,
              title: 'profile.menu_title.business_financial_institutions',
              icon: 'landmark',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/financial_facilities`,
              title: 'profile.menu_title.financial_facilities',
              icon: 'exchange-alt',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/rescheduling_restructuring`,
              title: 'profile.menu_title.writeOff_rescheduling_restructuring',
              icon: 'pencil-alt',
              iconType: 'fas'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/documents`,
              title: 'profile.menu_title.documents',
              icon: 'file-contract',
              iconType: 'fa'
            },
            ]
          }
        ],
        processMenuItems:[
          {
            title: 'general.process',
            icon: 'procedures',
            iconType: 'fa',
            children:[
              {
              link:  `/funder/clients/${this.$route.params.id}/view/internal-process`,
              title: 'general.internal_process',
              icon: 'project-diagram',
              iconType: 'fa'
              },
              {
              link: `/funder/clients/${this.$route.params.id}/view/customer-process`,
              title: 'general.credit_details',
              icon: 'credit-card',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/processs-documents`,
              title: 'general.documents',
              icon: 'file',
              iconType: 'fa'
            },

            ]
          }
        ]

    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue ===  `/supplier/customers/${this.$route.params.id}/view`) {
        this.$router.push( `/supplier/customers/${this.$route.params.id}/view/basic-info`)
      }else if (newValue ===  `/funder/clients/${this.$route.params.id}/view`) {
        this.$router.push( `/funder/clients/${this.$route.params.id}/view/basic-info`)
      }else if (newValue ===  `/anchor/customers/${this.$route.params.id}/view`) {
        this.$router.push( `/anchor/customers/${this.$route.params.id}/view/basic-info`)
      }
    },
  },
  computed: {
    ...mapGetters('customer', [
      'viewCustomer'
    ]),
    ...mapGetters('business', [
      'getBusinessPermission',
      'business',
      'allBusinessPermission',
    ]),

  },
  watch:{
  },
  created () {
    this.user=this.$route.params.id;
    if(this.viewCustomer == null){
      let res =  this.fetchViewCustomer(this.$route.params.id)
    }
    if (this.$route.path === `/supplier/customers/${this.$route.params.id}/view`) {
      this.$router.push( `/supplier/customers/${this.$route.params.id}/view/basic-info`)
    }else if (this.$route.path === `/funder/clients/${this.$route.params.id}/view`) {
      this.$router.push( `/funder/clients/${this.$route.params.id}/view/basic-info`)
    }
    else if (this.$route.path === `/anchor/customers/${this.$route.params.id}/view`) {
      this.$router.push( `/anchor/customers/${this.$route.params.id}/view/basic-info`)
    }
    if(localStorage.getItem('account_type')=='funder'){
      this.userType = 'funder';
      this.getBusinessData();
      this.finalMenuItems = [
        {
          title: 'general.basic_information',
          icon: 'info',
          iconType: 'fa',
          children:[
            {
              link: `/funder/clients/${this.$route.params.id}/view/basic-info`,
              title: 'clients.basic_info',
              icon: 'info-circle',
              iconType: 'fa'
            },
            {
              link: `/funder/clients/${this.$route.params.id}/view/billing-address`,
              title: 'clients.billing_address',
              icon: 'address-card',
              iconType: 'fa'
            },
            {
              link:  `/funder/clients/${this.$route.params.id}/view/shipping-address`,
              title: 'clients.shipping_address',
              icon: 'address-book',
              iconType: 'fa'
            },
          ]
        },
      ];
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType = 'supplier';
      this.finalMenuItems = [
        {
          title: 'general.basic_information',
          icon: 'info',
          iconType: 'fa',
          children:[
            {
              link: `/supplier/customers/${this.$route.params.id}/view/basic-info`,
              title: 'customers.basic_info',
              icon: 'info-circle',
              iconType: 'fa'
            },
            {
              link: `/supplier/customers/${this.$route.params.id}/view/billing-address`,
              title: 'customers.billing_address',
              icon: 'address-card',
              iconType: 'fa'
            },
            {
              link:  `/supplier/customers/${this.$route.params.id}/view/shipping-address`,
              title: 'customers.shipping_address',
              icon: 'address-book',
              iconType: 'fa'
            },
          ]
        },
      ];
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType = 'anchor';
      this.finalMenuItems = [
        {
          title: 'general.basic_information',
          icon: 'info',
          iconType: 'fa',
          children:[
            {
              link: `/anchor/customers/${this.$route.params.id}/view/basic-info`,
              title: 'customers.basic_info',
              icon: 'info-circle',
              iconType: 'fa'
            },
            {
              link: `/anchor/customers/${this.$route.params.id}/view/billing-address`,
              title: 'customers.billing_address',
              icon: 'address-card',
              iconType: 'fa'
            },
            {
              link:  `/anchor/customers/${this.$route.params.id}/view/shipping-address`,
              title: 'customers.shipping_address',
              icon: 'address-book',
              iconType: 'fa'
            },
          ]
        },
      ];
    }
  },
  destroyed(){
    this.falseBusinessPermission()
    this.unsetBusiness()
    this.unsetStakeholders()
    this.unsetFinancialFacilities()
    this.unsetProfileDocuments()
  },
  mounted(){
    $('.sub-menu ul').hide();
    $(".sub-menu a").click(function () {
      $(this).parent(".sub-menu").children("ul").slideToggle("100");
    });
  },
  methods: {
    ...mapActions('customer', [
      'fetchViewCustomer'
    ]),
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission',
      'unsetBusiness',
      'fetchBusinessByUser'
    ]),
    ...mapActions('stakeholder', [
      'unsetStakeholders',
    ]),
    ...mapActions('financialFacility', [
      'unsetFinancialFacilities'
    ]),
    ...mapActions('documentType', [
      'unsetProfileDocuments'
    ]),
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    },
    profileMenuToggle(id){
      $("#"+"profile-submenu-"+id).slideToggle("100");
    },
    processMenuToggle(id){
      $("#"+"process-submenu-"+id).slideToggle("100");
    },
    viewCustomerPage(){
      if(localStorage.getItem('account_type')=='funder'){
        this.$router.push(`/funder/clients/${this.$route.params.id}/view`)
      }else if(localStorage.getItem('account_type')=='supplier'){
        this.$router.push(`/supplier/customers/${this.$route.params.id}/view`)
      }else if(localStorage.getItem('account_type')=='anchor'){
        this.$router.push(`/anchor/customers/${this.$route.params.id}/view`)
      }
    },
    async getBusinessData(){
      let formData = {
        user_id: this.$route.params.id,
      }
      let  response = await this.fetchBusinessByUser(formData)
      if(response.data.result == true){
        this.funderProcessingMenu =true
      }else{
        this.funderProcessingMenu =false
      }
    }
  }
}
</script>
